import React, { useMemo } from 'react';
import useEditorSelectedElement from 'packages/hooks/useEditorSelectedElement';
import Shots from './Shots';
import Globals from './Globals';
import generateTestId from 'packages/helpers/testIdHelpers';

const testId = generateTestId('editor_sidebar');

const RightSideMenu = () => {
    const { selectedElement, selectedElements, topLevelSelectedElements } = useEditorSelectedElement();

    const isMultiSelection = useMemo(() => topLevelSelectedElements?.length > 1, [topLevelSelectedElements]);

    return (
        <div {...testId}>
            {selectedElement || isMultiSelection ? (
                <Shots
                    isMultiSelection={isMultiSelection}
                    selectedElement={selectedElement}
                    selectedElements={selectedElements}
                />
            ) : (
                <Globals />
            )}
        </div>
    );
};

export default RightSideMenu;
